var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDzoo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzoo0)",
    d: "M17.944 11.571c-.527 0-.913.287-.913.429c.381 0 1.14.171 1.14.857s-1.063 1.427-1.594 1.714c.908 0 2.28-.643 2.28-1.714c0-.806-.455-1.286-.913-1.286"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBA1A2",
    d: "M18.171 12.857c0-.857-.759-.93-1.14-.857v1.071c.549 0 .686.142.686.215h-.227c-.185.343-.686.57-.913.643v.642c.531-.214 1.594-.857 1.594-1.714"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzoo1)",
    d: "M5.627 11.571c.527 0 .913.287.913.429c-.382 0-1.14.171-1.14.857s1.062 1.427 1.594 1.714c-.909 0-2.28-.643-2.28-1.714c0-.806.454-1.286.913-1.286"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBA1A2",
    d: "M5.4 12.857c0-.857.758-.93 1.14-.857v1.071c-.549 0-.686.142-.686.215h.227c.184.343.686.57.913.643v.642c-.532-.214-1.594-.857-1.594-1.714"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzoo2)",
    d: "M9.96 6.643c.364-.343 1.521-1.715 2.057-2.357V6l-.686 3.857c-.609-.93-1.736-2.871-1.371-3.214"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzoo3)",
    d: "M14.065 6.643c-.364-.343-1.521-1.715-2.053-2.357V6l.686 3.857c.609-.93 1.732-2.871 1.372-3.214z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzoo4)",
    d: "M11.1 9c-.729-.857-1.063-2.786-1.14-3.643c-1.372 1.5-.3 3.287.227 4.071z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzoo5)",
    d: "M7.907 7.714c.184-1.2 1.444-2.07 2.057-2.357c-1.282 1.372-.686 3.287-.232 4.071c0 0-.278.026-.458 0c-.879-.12-1.367-1.714-1.367-1.714"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzoo6)",
    d: "M12.925 9c.729-.857 1.063-2.786 1.14-3.643c1.372 1.5.305 3.287-.227 4.071z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzoo7)",
    d: "M16.118 7.714c-.18-1.2-1.444-2.07-2.053-2.357c1.277 1.372.686 3.287.227 4.071c0 0 .283.026.459 0c.883-.12 1.371-1.714 1.371-1.714z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzoo8)",
    d: "M9.274 9.429c-.729-.515-1.517-2.216-1.822-3c-.548 1.542.532 2.927 1.14 3.428l.686-.428z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzoo9)",
    d: "M7.452 11.143c-1.645-1.372-.685-3.716 0-4.715c-.364 2.058.3 3.142.686 3.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzooa)",
    d: "M10.645 18.643c-.467-.437-.835-1.715-.913-2.357h1.826l.454 3.428c-.454-.643-.912-.643-1.367-1.071"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzoob)",
    d: "M13.384 18.643c.463-.437.836-1.715.913-2.357H12.47l-.459 3.428c.459-.643.913-.643 1.372-1.071"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzooc)",
    d: "M14.751 9.429c.729-.515 1.521-2.216 1.826-3c.544 1.542-.532 2.927-1.14 3.428z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzood)",
    d: "M16.577 11.143c1.641-1.372.685-3.716 0-4.715c.364 2.058-.305 3.142-.686 3.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzooe)",
    d: "M11.095 15.429c-.728.857-1.063 2.785-1.14 3.642c-1.371-1.5-.304-3.287.227-4.071z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzoof)",
    d: "M7.902 16.714c.18 1.2 1.445 2.07 2.053 2.357C8.678 17.7 9.27 15.784 9.728 15c0 0-.283-.026-.458 0c-.883.12-1.372 1.714-1.372 1.714z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzoog)",
    d: "M12.925 15.429c.729.857 1.063 2.785 1.14 3.642c1.372-1.5.305-3.287-.227-4.071z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzooh)",
    d: "M16.118 16.714c-.18 1.2-1.444 2.07-2.053 2.357c1.277-1.371.686-3.287.227-4.071c0 0 .283-.026.459 0c.883.12 1.371 1.714 1.371 1.714z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzooi)",
    d: "M9.27 15c-.729.514-1.522 2.216-1.822 3c-.548-1.543.532-2.927 1.14-3.429l.686.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzooj)",
    d: "M7.714 12.857c-1.642 1.372-.952 4.144-.27 5.143C7.08 15.943 8.618 14 9 13.714z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzook)",
    d: "M14.751 15c.729.514 1.521 2.216 1.826 3c.548-1.543-.532-2.927-1.14-3.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzool)",
    d: "M16.071 13.071c1.641 1.372 1.187 3.93.506 4.929c.364-2.057-.986-3.999-1.363-4.286z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzoom)",
    d: "M6.085 8.571c-1.645 2.743.455 5.143 1.822 5.143l-.455-1.286c-1.097-.342-1.371-2.712-1.371-3.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzoon)",
    d: "M7.907 10.286A5.8 5.8 0 0 1 6.08 8.57a3.3 3.3 0 0 0 1.371 3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzooo)",
    d: "M17.717 8.357c1.641 2.743-.227 4.573-1.372 5.143v-1.286c1.097-.343 1.372-2.713 1.372-3.857"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzoop)",
    d: "M15.891 10.071a5.8 5.8 0 0 0 1.826-1.714a3.3 3.3 0 0 1-1.372 3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzooq)",
    d: "M7.5 11.121c0-.835.784-2.485 2.558-2.485l-.493-.493c.742.085 1.727.428 2.435.857c.578-.429 1.388-.66 2.571-.857l-.429.497a2.72 2.72 0 0 1 2.358 2.48c0 .579-.129 1.886-1.513 2.482c.33.081.87.403.87 1.397c0 1.243-1.929 2.571-3.857 2.571c-1.479 0-3.429-.835-3.429-2.571c0-1.187.386-1.427.703-1.419c-.823-.145-1.976-.831-1.774-2.46"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzoor)",
    d: "M8.142 10.714c-.754 0-.857.429-.857.643c0 1.2 0 2.786.707 2.786h1.415c1.178 0 1.65-1.929 2.593-1.929c1.088 0 1.105 1.702 2.357 1.929h1.414c.943 0 .943-2.143.943-2.786c0-.514-.544-.643-.857-.643h-1.929c-.428 0-1.363.857-1.928.857c-.566 0-1.286-.857-1.886-.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzoos)",
    d: "M7.714 13.071v-.428l1.071-1.5h.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzoot)",
    d: "M13.714 13.071v-.428l1.071-1.5h.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzoou)",
    d: "M7.714 13.714v-.428l1.714-2.143h.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzoov)",
    d: "M13.714 13.714v-.428l1.714-2.143h.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzoow)",
    d: "M8.357 13.714h-.429l2.143-2.571h.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzoox)",
    d: "M14.357 13.714h-.429l2.143-2.571h.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzooy)",
    d: "M12.857 14.571h-1.715c-.428 0-.428.245-.428.489s.428 1.226 1.286 1.226c.857 0 1.285-.733 1.285-1.226c0-.39-.287-.489-.428-.489"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDzooz)",
    d: "M12.03 15c-.3 0-.823.501-.948.643c.185.428.549.643.918.643c.368 0 .732-.215.917-.643c-.129-.142-.583-.643-.887-.643"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020207",
    d: "M11.37 14.143h.458s-.304-.429-.458-.429c-.15 0-.228.095-.228.214c0 .12.078.215.228.215m1.298 0h-.454s.304-.429.454-.429c.154 0 .232.095.232.214c0 .12-.078.215-.232.215"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzoo0",
    x1: 16.039,
    x2: 12.481,
    y1: 5.388,
    y2: 20.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BCC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#158885"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzoo1",
    x1: 7.532,
    x2: 11.09,
    y1: 5.388,
    y2: 20.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BCC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#158885"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzoo2",
    x1: 11.765,
    x2: 11.765,
    y1: 4.286,
    y2: 19.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E9284"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76BE62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzoo3",
    x1: 7.763,
    x2: 8.386,
    y1: 4.879,
    y2: 19.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ECB63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DBA76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzoo4",
    x1: 12.262,
    x2: 12.262,
    y1: 4.286,
    y2: 19.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D827C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58B56E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzoo5",
    x1: 11.785,
    x2: 11.785,
    y1: 4.286,
    y2: 19.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70AB6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EA881"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzoo6",
    x1: 14.884,
    x2: 14.884,
    y1: 3.474,
    y2: 18.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D827C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58B56E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzoo7",
    x1: 14.909,
    x2: 14.909,
    y1: 3.476,
    y2: 18.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70AB6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EA881"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzoo8",
    x1: 5.792,
    x2: 9.541,
    y1: 5.25,
    y2: 21.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#199584"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AB562"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzoo9",
    x1: 11.786,
    x2: 11.786,
    y1: 4.286,
    y2: 19.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EB374"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4AB67C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74B960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzooa",
    x1: 11.785,
    x2: 11.785,
    y1: 4.286,
    y2: 19.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12837F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACDA5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzoob",
    x1: 11.772,
    x2: 11.772,
    y1: 4.286,
    y2: 19.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12837F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACDA5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzooc",
    x1: 21.042,
    x2: 17.296,
    y1: 4.286,
    y2: 20.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#199584"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AB562"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzood",
    x1: 15.827,
    x2: 15.827,
    y1: 3.584,
    y2: 19.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EB374"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4AB67C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74B960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzooe",
    x1: 12.266,
    x2: 12.266,
    y1: 19.714,
    y2: 4.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D827C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58B56E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzoof",
    x1: 11.785,
    x2: 11.785,
    y1: 19.714,
    y2: 4.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70AB6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EA881"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzoog",
    x1: 11.304,
    x2: 11.304,
    y1: 19.714,
    y2: 4.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D827C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58B56E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzooh",
    x1: 11.785,
    x2: 11.785,
    y1: 19.714,
    y2: 4.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70AB6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EA881"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzooi",
    x1: 5.792,
    x2: 9.541,
    y1: 18.75,
    y2: 2.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#199584"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AB562"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzooj",
    x1: 8.626,
    x2: 8.626,
    y1: 19.714,
    y2: 5.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EB374"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4AB67C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74B960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzook",
    x1: 17.778,
    x2: 14.015,
    y1: 18.75,
    y2: 2.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#199584"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AB562"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzool",
    x1: 15.238,
    x2: 15.238,
    y1: 19.714,
    y2: 4.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EB374"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4AB67C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74B960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzoom",
    x1: 6.88,
    x2: 8.884,
    y1: 6.214,
    y2: 19.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84BA5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D9B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzoon",
    x1: 4.827,
    x2: 10.56,
    y1: 4.286,
    y2: 19.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#108A82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42A77F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzooo",
    x1: 20.726,
    x2: 19.046,
    y1: 6.214,
    y2: 19.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84BA5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D9B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzoop",
    x1: 23.98,
    x2: 18.268,
    y1: 4.286,
    y2: 19.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#108A82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42A77F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzooq",
    x1: 11.851,
    x2: 12.436,
    y1: 5.506,
    y2: 19.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFE6E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF888B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzoor",
    x1: 11.464,
    x2: 14.665,
    y1: 6.214,
    y2: 17.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#041D21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#050306"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzoos",
    x1: 16.836,
    x2: 7.286,
    y1: 4.286,
    y2: 21.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#394F51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#374D50",
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzoot",
    x1: 16.836,
    x2: 7.286,
    y1: 4.286,
    y2: 21.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#394F51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#374D50",
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzoou",
    x1: 13.2,
    x2: 5.791,
    y1: 9.428,
    y2: 21.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#394F51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#374D50",
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzoov",
    x1: 13.2,
    x2: 5.791,
    y1: 9.428,
    y2: 21.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#394F51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#374D50",
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzoow",
    x1: 15.321,
    x2: 7.37,
    y1: 9.428,
    y2: 20.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#394F51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#374D50",
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzoox",
    x1: 15.321,
    x2: 7.37,
    y1: 9.428,
    y2: 20.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#394F51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#374D50",
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzooy",
    x1: 11.785,
    x2: 11.785,
    y1: 4.286,
    y2: 19.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#021B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDzooz",
    x1: 15.123,
    x2: 15.123,
    y1: 1.714,
    y2: 14.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C1B15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E0002"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDzoo);
export default __webpack_public_path__ + "static/media/dzoo.b86d550a439e3998306323f38b0c5e05.svg";
export { ForwardRef as ReactComponent };